import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import ViewType from "~/@types/viewType";

export interface KitBuilderInvocation {
	generation: number;
	itemIds: string[];
	sessionId: string;
}

interface KittingState {
	invocation: KitBuilderInvocation | null;
	viewType: ViewType;
}

const initialState: KittingState = {
	invocation: null,
	viewType: "card"
};

const kittingSlice = createSlice({
	initialState,
	name: "restockKitting",
	reducers: {
		invokeKitBuilder: (state, action: PayloadAction<Omit<KitBuilderInvocation, "generation">>) => {
			state.invocation = { ...action.payload, generation: (state.invocation?.generation ?? 0) + 1 };
		},
		setViewType: (state, action: PayloadAction<ViewType>) => {
			state.viewType = action.payload;
		}
	}
});

export const { invokeKitBuilder, setViewType } = kittingSlice.actions;

export default kittingSlice.reducer;
